import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { authClient } from "@/lib/auth-client";
import type { UserSession } from "@/utils/custom-types";

export const Route = createFileRoute("/_public/_auth")({
	beforeLoad: async ({ context, location }) => {
		const { queryClient } = context;
		const session: UserSession | null = await queryClient.fetchQuery({
			queryKey: ["session"],
			queryFn: async () => {
				const { data } = await authClient.getSession();
				return data ?? null;
			}
		});

		// const response = await authClient.getSession();
		// const session = response.data as UserSession | null;

		if (!session) return;

		throw redirect({
			to: "/$workspaceId",
			params: { workspaceId: String(session.user.lastWorkspaceId) },
		});
	},
	component: () => <Outlet />,
});
